/* viewConfig */

var viewConfig = function() {
	var configCache = {};

	function _check(settingKey){
		if(typeof configCache[settingKey] !== 'undefined'){
			
			return configCache[settingKey];
			
		}

		var res = false;
		
		if(typeof viewSettings !== 'undefined' && typeof viewSettings[settingKey] !== "undefined" && viewSettings[settingKey]){
			res = true;
		}

		configCache[settingKey] = res;
		return res;
	}

	return {
		check: _check
	};
}();